import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    padding: 150px 60px 100px 60px;
    background: url(${props => props.bgDesktop }) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 1400px) {
        padding: 40px;
        flex-direction: column;
    }

    @media (max-width: 900px) {
        background: url(${props => props.bgMobile }) center top #000 no-repeat;
        background-size: cover;
        padding: 150px 20px 40px 20px;
    }

    @media (max-width: 500px) {
        background: url(${props => props.bgMobile }) center top #000 no-repeat;
        background-size: cover;
        padding: 100px 20px 40px 20px;
    }
`

export const BoxCol6 = styled.div`
    float: left;
    width: 50%;
    padding: 0 15px;
    text-align: center;

    @media (max-width: 1400px) {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0;

        &.boxTextos {
            margin-bottom: 20px;
        }
    }
`

export const BoxCol4 = styled.div`
    float: left;
    width: 40%;
    padding: 0 15px;
    text-align: center;

    @media (max-width: 1400px) {
        width: 100%;
    }
`

export const ImagemPrincipal = styled.img`
    max-width: 100%;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        max-width: 70%;
    }
`

export const TextoBanner = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 22px;
    line-height: 32px;
    font-weight: 600;
    text-transform: uppercase;

    strong {
        color: #F09C00;
    }

    @media (max-width: 1600px) {
        br {
            display: none;
        }
    }

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 25px;
        margin-bottom: 0;
    }
`

export const BoxEconomize = styled.div `
    float: left;
    width: 100%;
    background: #F09C00;
    padding: 15px;
    border-radius: 8px;

    @media (max-width: 768px) {
        padding: 10px;
    }
`

export const BoxEconomizeTexto = styled.span `
    color: #000000;
    font-size: 20px;
    font-weight: 900;
    line-height: 30px;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 14px;
        line-height: 24px;
    }
`

export const BoxAssinaturas = styled.div `
    float: left;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
    margin-top: 20px;

    @media (max-width: 1400px) {
        gap: 20px;
    }

    @media (max-width: 768px) {
        gap: 5px
    }
`

export const ItemAssinatura = styled.div `
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 15px;

    @media (max-width: 768px) {
        padding: 10px;
    }
`

export const ItemAssinaturaTag = styled.span `
    background-color: ${props => props.primeiro ? '#F09C00' : '#565769' };
    float: left;
    width: 100%;
    border-radius: 100px;
    padding: 10px;
    text-align: center;
    font-size: 13px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 11px;
        line-height: 22px;
        padding: 5px;
    }
`

export const ItemAssinaturaTitulo = styled.span `
    float: left;
    width: 100%;
    color: #121520;
    font-size: 24px;
    font-weight: 900;
    margin: 20px 0;
    padding: 0 30px;
    line-height: 34px;

    @media (max-width: 1600px) {
        padding: 0;
        font-size: 18px;
        line-height: 26px;
    }

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 22px;
        margin: 10px 0 15px 0;
    }
`

export const ItemAssinaturaPrecoDe = styled.span `
    float: left;
    width: 100%;
    color: #565769;
    text-decoration: line-through;
    font-size: 14px;
    margin-bottom: 5px;

    @media (max-width: 768px) {
        font-size: 13px;
    }
`

export const ItemAssinaturaPrecoPor = styled.span `
    float: left;
    width: 100%;
    color: #121520;
    font-size: 14px;

    strong {
        font-size: 30px;
        font-weight: 900;

        @media (max-width: 768px) {
            font-size: 20px;
            letter-spacing: -0.5px;
        }
    }

    @media (max-width: 768px) {
        font-size: 12px;
    }
`

export const ItemAssinaturaLinkCartao = styled.a `
    float: left;
    width: 100%;
    color: #F09C00;
    border: solid 2px #F09C00;
    margin: 20px 0 10px 0;
    padding: 10px 5px;
    font-size: 14px;
    border-radius: 8px;
    font-weight: bold;

    @media (max-width: 768px) {
        border: solid 1px #F09C00;
        margin: 15px 0 5px 0;
        padding: 10px 5px;
        font-size: 10px;
    }
`

export const ItemAssinaturaLinkAVista = styled.a `
    float: left;
    width: 100%;
    color: #fff;
    background-color: #C98400;
    padding: 10px 5px;
    font-size: 14px;
    border-radius: 8px;
    font-weight: bold;

    @media (max-width: 768px) {
        padding: 10px 5px;
        font-size: 10px;
    }
`
